import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';
import { Badge } from '../Badge';

const mAndAIconStyles = {
  badge: {
    position: 'relative',
    display: 'inline-flex',
    marginLeft: '0.375rem',
    alignSelf: 'flex-start',
  },
};

type MAndAIconProps = {
  enabled?: boolean;
} & ComponentProps<typeof Badge>;

export const MAndAIcon = ({ enabled, sx }: MAndAIconProps) => {
  if (!enabled) {
    return null;
  }

  return (
    <Badge
      data-id='ma-icon'
      component='span'
      variant='ma'
      sx={combineSx(mAndAIconStyles.badge, sx)}
    >
      M&A
    </Badge>
  );
};
